import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { QrCodeIcon } from "@jti/brand-icons/qr-code";
import { Button } from "../../components/Button";
import { SharableProfileDialog } from "./SharableProfileDialog/SharableProfileDialog";
import styles from "./SharableProfile.module.scss";
export const SharableProfile = ({ userInfo, userId, referralCode, isDialogOpenedManually = false, portalDomNode, }) => {
    const [isShareProfileDialogOpened, setIsShareProfileDialogOpened] = useState(isDialogOpenedManually);
    const toggleDialog = () => {
        setIsShareProfileDialogOpened((prevState) => !prevState);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { "data-testid": "openSharableProfileDialog", onClick: toggleDialog, size: "small", color: "secondary", children: _jsx(QrCodeIcon, { className: styles.shareProfile }) }), _jsx(SharableProfileDialog, { userInfo: userInfo, userId: userId, referralCode: referralCode, isOpened: isShareProfileDialogOpened, onClose: toggleDialog, portalDomNode: portalDomNode })] }));
};
//# sourceMappingURL=SharableProfile.js.map